<template>
  <main id="HomePage">
    <CoverSection ref="CoverSection" />
    <ContactSection ref="ContactSection" />
    <ProductSection
      ref="ProductSection"
      title="優惠車款"
      link="/collections?category=8"
      menu-id="8"
    />
    <ProductSection
      ref="Product2Section"
      title="電動車款"
      link="/collections?category=11"
      menu-id="11"
    />
    <ProductSection
      ref="Product3Section"
      title="燃油車款"
      link="/collections?category=12"
      menu-id="12"
    />

    <ApplicationSection ref="ApplicationSection" />

    <AboutSection ref="AboutSection" />
    <ServiceSection ref="ServiceSection" />
    <NewsListSection ref="NewsListSection" />
  </main>
</template>

<script>
import CoverSection from "@/components/home/CoverSection.vue";
import ContactSection from "@/components/home/ContactSection.vue";
import ServiceSection from "@/components/home/ServiceSection.vue";
import AboutSection from "@/components/home/AboutSection.vue";
import ProductSection from "@/components/home/ProductSection.vue";
import NewsListSection from "@/components/home/NewsListSection.vue";
import ApplicationSection from "@/components/home/ApplicationSection.vue";
export default {
  name: "HomePageView",
  components: {
    CoverSection,
    ServiceSection,
    AboutSection,
    ProductSection,
    NewsListSection,
    ContactSection,
    ApplicationSection,
  },
  props: {
    imageLoaded: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    SetPageAnimation() {
      this.$refs.AboutSection.SetAnimation();
      this.$refs.ServiceSection.SetAnimation();
      this.$refs.ProductSection.SetAnimation();
      this.$refs.NewsListSection.SetAnimation();
    },
    PageInit() {
      console.log("page init");
      this.$emit("load-image");
      const metaData = this.$store.getters.pageMetaData("首頁");
      this.$emit("set-meta", {
        title: metaData.Title,
        content: metaData.Content,
        image: this.$store.getters.imageUrl(metaData.Image),
      });
    },
  },
  computed: {
    loadingFinish() {
      return this.$store.state.loadingFinish;
    },
    dataLoadStatus() {
      return this.$store.getters.allDataLoaded;
    },
  },
  watch: {
    imageLoaded() {
      if (this.imageLoaded && this.loadingFinish) {
        this.SetPageAnimation();
      }
    },
    loadingFinish() {
      if (this.imageLoaded && this.loadingFinish) {
        this.SetPageAnimation();
      }
    },
    dataLoadStatus() {
      this.$nextTick(() => {
        this.PageInit();
      });
    },
  },
  mounted() {
    if (this.dataLoadStatus) {
      this.PageInit();
    }
  },
};
</script>
